import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Experience() {
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation(0.3);

  return (
    <section
      id="experience"
      className="py-28 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, rgba(71,214,212,0.1) 0%, #fafafa 40%, rgba(71,214,212,0.07) 100%)' }}
    >
      {/* Decorative accents */}
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-[#47d6d4]/60 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-[#47d6d4]/60 to-transparent"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-[#47d6d4]/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative z-10 px-6 lg:px-20 max-w-2xl mx-auto text-center">
        <div
          ref={contentRef}
          className={`transition-all duration-[600ms] ease-out ${contentVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a3e] mb-5 leading-tight"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            まずは、体験から。
          </h2>
          <p className="text-[#e85d2c] text-sm font-semibold tracking-wide mb-7">
            55分の無料体験で、世界最高峰のシミュレーターを。
          </p>
          <p className="text-[#1a1a3e]/60 text-lg leading-[1.9] mb-12">
            完全無料・デポジット不要。公式LINEより体験の希望日時を送信してください。日程を個別に調整いたします。
          </p>
        </div>

        <div
          ref={ctaRef}
          className={`transition-all duration-[600ms] ease-out ${ctaVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
        >
          <a
            href="https://lin.ee/IX2y4CH"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#47d6d4] text-white font-bold px-10 py-4 rounded-full text-base hover:bg-[#3bc4c2] transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-line-fill text-xl"></i>
            公式LINEで無料体験を申し込む
          </a>
          <p className="text-[#1a1a3e]/30 text-xs mt-6">完全無料・デポジット不要</p>
        </div>
      </div>
    </section>
  );
}
